module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Chef-049c0971212f3e4d4e257d8c4207503a.svg";